import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { HelpModalComponent } from './help-modal.directive';

@Component({
  selector: 'h3-raster-coding-help-modal',
  templateUrl: './help-modal.directive.html',
  styleUrls: ['./help-modal.directive.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RasterCodingHelpModalComponent
  extends HelpModalComponent
  implements OnInit
{
  ngOnInit() {
    this.config = {
      tabs: [
        {
          name: 'Raster',
          sections: [
            this.getGeneralSection(),
            this.getToolsSection(),
            this.getEditSection(),
          ],
        },
      ],
    };
  }

  protected override getViewSettingsShortcuts() {
    return [
      ...super.getViewSettingsShortcuts(),
      ...this.getBrightnessAndContrastShortcuts(),
    ];
  }

  protected getAnnotationToolsShortcuts() {
    return [
      { name: 'Paintbrush tool', key: this.shortcut('selectPaintbrushTool') },
      { name: 'Fill tool', key: this.shortcut('selectFillTool') },
      { name: 'Superpixel tool', key: this.shortcut('selectSuperpixelTool') },
      { name: 'Measure tool', key: this.shortcut('selectMeasureTool') },
      { name: 'Zoom tool', key: this.shortcut('selectZoomTool') },
    ];
  }

  protected override getLayerViewSettingsShortcuts() {
    if (!this.isViewSettingsShortcutsOn) {
      return [
        { name: 'View mask', key: '1' },
        { name: 'View both', key: '2' },
        { name: 'View image', key: '3' },
      ];
    }
    return [
      {
        name: 'View mask/both/image',
        // fix me if you change this code
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
        key: this.isViewSettingsShortcutsOn && this.shortcut('cycleViewMode'),
      },
    ];
  }

  protected getNavigationShortcuts() {
    return [
      { name: 'Pan', key: this.panShortcut },
      { name: 'Zoom', key: 'SCROLL' },
      { name: 'Reset zoom', key: '0' },
      {
        name: 'Toggle zoom panel',
        key: this.shortcut('toggleZoomPanel'),
      },
    ];
  }

  private getGeneralSection() {
    return {
      name: 'General',
      shortcuts: [
        ...this.getViewSettingsShortcuts(),
        ...this.getLayerViewSettingsShortcuts(),
        ...this.getUndoRedoShortcuts(),
        ...this.getNavigationShortcuts(),
      ],
    };
  }

  private getToolsSection() {
    return {
      name: 'Tools',
      shortcuts: this.getAnnotationToolsShortcuts(),
    };
  }

  private getEditSection() {
    return {
      name: 'Edit',
      shortcuts: [
        {
          name: 'Erase (no label)',
          key: `${this.modifier('altKey')}+CLICK`,
        },
      ],
    };
  }
}
